// api
import { apiSliceV2 } from '@/api/apiSlice';

export const alarmsApiSlice = apiSliceV2.injectEndpoints({
  tagTypes: ['Alarm', 'AlarmTypes'],
  endpoints: (builder) => ({
    getAlarmsByAccount: builder.query({
      query: (args) => {
        const accountId = args;
        return {
          url: `/Alarms?AccountIds=${accountId}&OrderBy=Created&OrderDirection=desc&top=1000&Skip=0`,
        };
      },
      providesTags: ['Alarm'],
    }),
    getAlarmsFeedByAccount: builder.query({
      query: (args) => {
        const accountId = args;
        return {
          url: `/Alarms/Feed?AccountIds=${accountId}&OrderBy=Created&OrderDirection=desc&top=1000&Skip=0`,
        };
      },
      providesTags: ['Alarm'],
    }),
    getAlarms: builder.query({
      query: () => {
        return {
          url: `/Alarms?OrderBy=Created&State=eq(Unresolved)&top=2000`,
        };
      },
      providesTags: ['Alarm'],
    }),
    updateAlarm: builder.mutation({
      query: (args) => {
        const { alarmId, alarm } = args;
        return {
          url: `/Alarms/${alarmId}`,
          method: 'PATCH',
          body: alarm,
        };
      },
      invalidatesTags: ['Alarm'],
    }),
    getAlarmTypes: builder.query({
      query: () => {
        return {
          url: `/AlarmTypes`,
        };
      },
      providesTags: ['AlarmTypes'],
    }),
    getAlarmById: builder.query({
      query: (args) => {
        const alarmId = args;
        return {
          url: `/Alarms/${alarmId}`,
        };
      },
      providesTags: ['Alarm'],
    }),
  }),
});

export const {
  useGetAlarmsByAccountQuery,
  useGetAlarmsFeedByAccountQuery,
  useGetAlarmTypesQuery,
  useGetAlarmsQuery,
  useUpdateAlarmMutation,
  useGetAlarmByIdQuery,
} = alarmsApiSlice;
